export enum LOCALES {
  EN_GB = "en-GB",
  EN_US = "en-US",
  HE_IL = "he-IL",
}

export const rtlLocales: Array<string> = [LOCALES.HE_IL];
